import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { LastMeasureProductionEvent } from '../last-measure-production-event';

export class LastMeasureProductionEventBuilder {
  static fromJson(json) {
    return (json)
      ? new LastMeasureProductionEvent(
        json.productionEventHash,
        json.productionEventEndTime,
        json.programHash,
        json.programReference,
        json.toolName,
        json.toolHolderName,
        parseNumber(json.pocket)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(LastMeasureProductionEventBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/last-measurepproduction-event.builder.ts